module.exports = __webpack_public_path__ + "media/images/address-dedca1ca1fab4f915c865284fe9838c6.svg";